import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

enum PeriodType {
  当前周期 = 0,
  上个周期 = 1,
}

export const get_chatting_anchor_rank = createAsyncThunk(
  'PaidUserUnderTakingGroup/get_chatting_anchor_rank',
  async (params: any = {}, store: any) => {
    const resp = await http.post('/live/chatting/chatting_anchor_rank', {
      ...store.getState().env.deviceinfo,
      type: PeriodType.当前周期,
    })
    return resp.data.data
  }
)
export const get_chatting_anchor_rank_pre = createAsyncThunk(
  'PaidUserUnderTakingGroup/get_chatting_anchor_rank_pre',
  async (params: any = {}, store: any) => {
    const resp = await http.post('/live/chatting/chatting_anchor_rank', {
      ...store.getState().env.deviceinfo,
      type: PeriodType.上个周期,
    })
    return resp.data.data
  }
)
export const get_chatting_work_detail = createAsyncThunk(
  'PaidUserUnderTakingGroup/chatting_work_detail',
  async (params: any = {}, store: any) => {
    const resp = await http.post('/live/chatting/chatting_work_detail', {
      ...store.getState().env.deviceinfo,
      type: PeriodType.当前周期,
    })
    return resp.data.data
  }
)
export const get_chatting_work_detail_pre = createAsyncThunk(
  'PaidUserUnderTakingGroup/get_chatting_work_detail_pre',
  async (params: any = {}, store: any) => {
    const resp = await http.post('/live/chatting/chatting_work_detail', {
      ...store.getState().env.deviceinfo,
      type: PeriodType.上个周期,
    })
    return resp.data.data
  }
)

export interface InitialStateType {
  workDetailInfo: {
    curList: Array<any>
    period_time?: string
    preList?: Array<any>
  }
  rankInfo: {
    gap_coins?: number
    period_time?: string
    curList: Array<any>
    preList: Array<any>
    my_info: any
  }
}

const initialState: InitialStateType = {
  workDetailInfo: {
    curList: [],
    preList: [],
  },
  rankInfo: {
    curList: [],
    preList: [],
    my_info: {},
  },
}

export const PaidUserUnderTakingGroupSlice = createSlice({
  name: 'PaidUserUnderTakingGroupSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_chatting_anchor_rank.fulfilled, (state, action) => {
      const {list = [], gap_coins, my_info = {}} = action.payload
      const {rankInfo} = state
      Object.assign(state, {
        rankInfo: {
          ...rankInfo,
          curList: list,
          gap_coins,
          my_info,
        },
      })
    })
    builder.addCase(get_chatting_anchor_rank_pre.fulfilled, (state, action) => {
      const {list = [], period_time} = action.payload
      const {rankInfo} = state
      Object.assign(state, {
        rankInfo: {
          ...rankInfo,
          preList: list,
          period_time,
        },
      })
    })
    builder.addCase(get_chatting_work_detail.fulfilled, (state, action) => {
      const {list = []} = action.payload
      const {workDetailInfo} = state
      Object.assign(state, {
        workDetailInfo: {
          ...workDetailInfo,
          curList: list,
        },
      })
    })
    builder.addCase(get_chatting_work_detail_pre.fulfilled, (state, action) => {
      const {list = [], period_time} = action.payload
      const {workDetailInfo} = state
      Object.assign(state, {
        workDetailInfo: {
          ...workDetailInfo,
          preList: list,
          period_time,
        },
      })
    })
  },
})
export default PaidUserUnderTakingGroupSlice.reducer
export const PaidUserUnderTakingGroupActions =
  PaidUserUnderTakingGroupSlice.actions

export const usePaidUserUnderTakingGroupState = () => {
  const data = useSelector((state) => {
    return state.PaidUserUnderTakingGroup
  })
  return data
}
